angular.module('zc.projects')

.directive 'reportDownloadButton', ($q, MasterReportStats, masterReportsCsvHeaders) ->
  restrict: 'E'
  scope:
    currentPeriod: '='
    projects: '='
  template: """
            <button
              type="button"
              class="btn btn-default pull-right"
              ng-csv="getCSV()"
              filename="{{filename}}"
              add-bom="true"
              charset="utf-16"
              field-separator="\\t">
              <i class="fa fa-cloud-download"></i> {{ 'masterReports.reportDownloadButton.csvDownload' | translate }}
            </button>
            """

  link: (scope, element, attrs) ->
    # filers header is like YYYY/M/D
    extraHeader = (statsForCSV) ->
      _.chain statsForCSV
       .values()
       .reduce _.assignIn, {}
       .keys()
       .filter (key) -> /\d{4,4}\/\d{1,2}\/\d{1,2}/.test(key)
       .uniq()
       .value()

    scope.filename = "reports_#{moment(scope.currentPeriod).format('YYYYMMDD')}.csv"
    scope.getCSV = ->
      $q (resolve) ->
        start_at = scope.currentPeriod.valueOf()
        end_at = moment(scope.currentPeriod).endOf("month").add(1, "days").startOf("month").valueOf()
        MasterReportStats.find
          # If contracted in middle of month, the report's begin_at is not
          # the first day of the month, so need to use $gte, $lt
          begin_at:
            $gte: start_at
            $lt: end_at
          dimension: 'daily'
          device: null
          target: null
        .then (report_stats) ->
          MasterReportStats.forCSV(report_stats)
        .then (statsForCSV) ->
          csvHeader = masterReportsCsvHeaders.concat extraHeader(statsForCSV)
          csvData = [csvHeader]
          for project in scope.projects
            # need to download all projects even when there is no stats found in report
            projectStats = statsForCSV[project.apikey] || project
            projectStats.status = project.contract_status
            row = (_.get(projectStats, header) for header in csvHeader)
            csvData.push row
          resolve csvData



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.reports/report_download_button.directive.coffee